var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusTop"},[_c('div',[_c('img',{staticStyle:{"height":"10.75rem"},attrs:{"src":require("@/assets/images/logo_hp.png"),"alt":""}})]),_vm._v(" "),_c('p',[_vm._v("请认真填写申请信息，以便我们为您提供更好的服务！")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-302a8016","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/centLogo.vue
// module id = null
// module chunks = 